import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import CourseVideoCard from "../../../../../components/CourseVideoCard";
import {CourseService} from "../../../../services/course-api.service";
import {Empty, message, Spin} from "antd";
import "./CourseDetails.scss";

const CourseDetails = () => {
  const navigate = useNavigate();
  const { id: courseId } = useParams();
  const [course, setCourse] = useState(null);
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    if (courseId) {
      fetchCourseDetails(courseId);
    }
  }, [courseId]);

  const fetchCourseDetails = async (id) => {
    try {
      setLoading(true);
      const response = await CourseService.getCourseById(id);
      if (response.data?.data.data) {
        const courseData = response.data.data.data;
        
        // Calculate videos watched from video details
        const videosWatchedCount = courseData.videoDetails 
          ? courseData.videoDetails.filter(video => video.vaultWatchHistory?.watchedAt).length 
          : 0;

        // Format course data
        setCourse({
          id: courseData._id,
          image: courseData.thumbnail,
          title: courseData.title,
          author: courseData.userDetails?.fullName || "Unknown Author",
          experience: courseData.userDetails?.additionalFields?.businessIndustry || "Educator",
          videos: courseData.videoCount || courseData.videos?.length || 0,
          description: courseData.description,
          videosWatched: courseData.videosWatched
        });
        
        // Format video data if available
        if (courseData.videoDetails && Array.isArray(courseData.videoDetails)) {
          const formattedVideos = courseData.videoDetails.map((video, index) => ({
            id: video._id,
            number: index + 1,
            thumbnail: video.thumbnail || courseData.thumbnail,
            title: video.name,
            duration: video.length || "00:00",
            current: video.vaultWatchHistory?.watchedAt, // We'll need to get watch history to set this correctly
            date: new Date(video.createdAt).toLocaleDateString(),
          }));
          setVideos(formattedVideos);
        }
      }
    } catch (err) {
      console.error("Error fetching course details:", err);
      setError("Failed to load course details. Please try again later.");
      message.error("Failed to load course details");
    } finally {
      setLoading(false);
    }
  };
  
  // Handle click on video card
  const handleVideoClick = (video) => {
    // Navigate to video details page using the video ID
    navigate(`/courses/${courseId}/videos/${video.id}`);
  };

  if (loading) {
    return (
      <div className="course-details-page loading">
        <div className="loading-container">
          <Spin size="large" />
        </div>
      </div>
    );
  }

  if (error || !course) {
    return (
      <div className="course-details-page error">
        <div className="error-container">
          <Empty description={error || "Course not found"} />
        </div>
      </div>
    );
  }

  return (
    <div className="course-details-page">
      <div className="course-details-header">
        <div className="course-details-image">
          <img src={course.image} alt={course.title} />
        </div>
        <div className="course-details-info">
          <h2>{course.title}</h2>
          {/* <p className="author">By {course.author}</p>
          <p className="experience">{course.experience}</p> */}
          <p className="videos">{course.videosWatched} / {course.videos} Videos</p>
          {course.description && <p className="description">{course.description}</p>}
        </div>
      </div>
      <div className="course-details-videos-section">
        <div className="videos-header">
          <span>Videos</span>
          {/*<span className="videos-count">{videos.length} Videos</span>*/}
        </div>
        {videos.length > 0 ? (
          <div className="course-videos-grid">
            {videos.map((video) => (
              <div key={video.id} className="video-card-wrapper" onClick={() => handleVideoClick(video)}>
                <CourseVideoCard {...video} />
              </div>
            ))}
          </div>
        ) : (
          <div className="empty-videos">
            <Empty description="No videos available" />
          </div>
        )}
      </div>
    </div>
  );
};

export default CourseDetails;